import { ComponentType } from '@/configuration/component/component-types'

export enum ActionType {
    OilAnalysisReportSubmitted = 1,
    OilAnalysisReportInvalidated,
    OilAnalysisUndoReportInvalidation,
    AnalysisCommentSubmitted,
    AnalysisCommentEdited,
    AnalysisCommentDeleted,
    ConditionStatusManuallyOverridden,
    ThresholdEdited,
    RecommendationSubmitted,
    RecommendationEdited,
    VisualInspectionReportSubmitted,
    ComponentConditionStatusCritical,
    ChangeInComponentConditionStatus,
    LastSynced,
    MarkedAsNoAction,
    UnmarkedAsNoAction,
    ReportSubmitted,
    ReportInvalidated,
    UndoReportInvalidation,
    VisualAnalysisReportSubmitted,
    ActionOverdue,
    MeasurementSetAsReference,
}

export const ActionTypes = {
    [ActionType.OilAnalysisReportSubmitted]:{
        labelKey: 'dashboard.notifications.actions.1',
        shortLabelKey: 'dashboard.notifications.shortActions.1',
        value: ActionType.OilAnalysisReportSubmitted,
    },
    [ActionType.OilAnalysisReportInvalidated]: {
        labelKey: 'dashboard.notifications.actions.2',
        shortLabelKey: 'dashboard.notifications.shortActions.2',
        value: ActionType.OilAnalysisReportInvalidated,
    },
    [ActionType.OilAnalysisUndoReportInvalidation]:{
        labelKey: 'dashboard.notifications.actions.3',
        shortLabelKey: 'dashboard.notifications.shortActions.3',
        value: ActionType.OilAnalysisUndoReportInvalidation,
    },
    [ActionType.AnalysisCommentSubmitted]: {
        labelKey: 'dashboard.notifications.actions.4',
        shortLabelKey: 'dashboard.notifications.shortActions.4',
        value: ActionType.AnalysisCommentSubmitted,
    },
    [ActionType.AnalysisCommentEdited]: {
        labelKey: 'dashboard.notifications.actions.5',
        shortLabelKey: 'dashboard.notifications.shortActions.5',
        value: ActionType.AnalysisCommentEdited,
    },
    [ActionType.AnalysisCommentDeleted]: {
        labelKey: 'dashboard.notifications.actions.6',
        shortLabelKey: 'dashboard.notifications.shortActions.6',
        value: ActionType.AnalysisCommentDeleted,
    },
    [ActionType.ConditionStatusManuallyOverridden]: {
        labelKey: 'dashboard.notifications.actions.7',
        shortLabelKey: 'dashboard.notifications.shortActions.7',
        value: ActionType.ConditionStatusManuallyOverridden,
    },
    [ActionType.ThresholdEdited]: {
        labelKey: 'dashboard.notifications.actions.8',
        shortLabelKey: 'dashboard.notifications.shortActions.8',
        value: ActionType.ThresholdEdited,
    },
    [ActionType.RecommendationSubmitted]: {
        labelKey: 'dashboard.notifications.actions.9',
        shortLabelKey: 'dashboard.notifications.shortActions.9',
        value: ActionType.RecommendationSubmitted,
    },
    [ActionType.RecommendationEdited]: {
        labelKey: 'dashboard.notifications.actions.10',
        shortLabelKey: 'dashboard.notifications.shortActions.10',
        value: ActionType.RecommendationEdited,
    },
    [ActionType.VisualInspectionReportSubmitted]: {
        labelKey: 'dashboard.notifications.actions.11',
        shortLabelKey: 'dashboard.notifications.shortActions.11',
        value: ActionType.VisualInspectionReportSubmitted,
    },
    [ActionType.ComponentConditionStatusCritical]: {
        labelKey: 'dashboard.notifications.actions.12',
        shortLabelKey: 'dashboard.notifications.shortActions.12',
        value: ActionType.ComponentConditionStatusCritical,
    },
    [ActionType.ChangeInComponentConditionStatus]: {
        labelKey: 'dashboard.notifications.actions.13',
        shortLabelKey: 'dashboard.notifications.shortActions.13',
        value: ActionType.ChangeInComponentConditionStatus,
    },
    [ActionType.LastSynced]: {
        labelKey: 'dashboard.notifications.actions.14',
        shortLabelKey: 'dashboard.notifications.shortActions.14',
        value: ActionType.LastSynced,
    },
    [ActionType.MarkedAsNoAction]: {
        labelKey: 'dashboard.notifications.actions.15',
        shortLabelKey: 'dashboard.notifications.shortActions.15',
        value: ActionType.MarkedAsNoAction,
    },
    [ActionType.UnmarkedAsNoAction]: {
        labelKey: 'dashboard.notifications.actions.16',
        shortLabelKey: 'dashboard.notifications.shortActions.16',
        value: ActionType.UnmarkedAsNoAction,
    },
    [ActionType.ReportSubmitted]: {
        labelKey: 'dashboard.notifications.actions.17',
        shortLabelKey: 'dashboard.notifications.shortActions.17',
        value: ActionType.ReportSubmitted,
    },
    [ActionType.ReportInvalidated]: {
        labelKey: 'dashboard.notifications.actions.18',
        shortLabelKey: 'dashboard.notifications.shortActions.18',
        value: ActionType.ReportInvalidated,
    },
    [ActionType.UndoReportInvalidation]: {
        labelKey: 'dashboard.notifications.actions.19',
        shortLabelKey: 'dashboard.notifications.shortActions.19',
        value: ActionType.UndoReportInvalidation,
    },
    [ActionType.VisualAnalysisReportSubmitted]: {
        labelKey: 'dashboard.notifications.actions.20',
        shortLabelKey: 'dashboard.notifications.shortActions.20',
        value: ActionType.VisualAnalysisReportSubmitted,
    },
    [ActionType.ActionOverdue]: {
        labelKey: 'dashboard.notifications.actions.21',
        shortLabelKey: 'dashboard.notifications.shortActions.21',
        value: ActionType.ActionOverdue,
    },
    [ActionType.MeasurementSetAsReference]: {
        labelKey: 'dashboard.notifications.actions.22',
        shortLabelKey: 'dashboard.notifications.shortActions.22',
        value: ActionType.MeasurementSetAsReference,
    },
} as const

interface ComponentActionStructure {
    labelKey: string
    shortLabelKey: string
    value: ActionType
}

export type ComponentSelectorStructure = {
    [key in ComponentType]: ComponentActionStructure[]
}

export const ComponentActionConfiguration: ComponentSelectorStructure = {
    [ComponentType.Transformer]: [
        ActionTypes[ActionType.ComponentConditionStatusCritical],
        ActionTypes[ActionType.ChangeInComponentConditionStatus],
        ActionTypes[ActionType.OilAnalysisReportSubmitted],
        ActionTypes[ActionType.VisualAnalysisReportSubmitted],
        ActionTypes[ActionType.AnalysisCommentSubmitted],
        ActionTypes[ActionType.RecommendationSubmitted],
        ActionTypes[ActionType.ConditionStatusManuallyOverridden],
        ActionTypes[ActionType.OilAnalysisReportInvalidated],
        ActionTypes[ActionType.OilAnalysisUndoReportInvalidation],
        ActionTypes[ActionType.RecommendationEdited],
        ActionTypes[ActionType.AnalysisCommentEdited],
        ActionTypes[ActionType.AnalysisCommentDeleted],
        ActionTypes[ActionType.ThresholdEdited],
        ActionTypes[ActionType.MarkedAsNoAction],
        ActionTypes[ActionType.UnmarkedAsNoAction],
        ActionTypes[ActionType.ActionOverdue],
    ],
    [ComponentType.Generator]: [
        ActionTypes[ActionType.ComponentConditionStatusCritical],
        ActionTypes[ActionType.ChangeInComponentConditionStatus],
        ActionTypes[ActionType.ReportSubmitted],
        ActionTypes[ActionType.AnalysisCommentSubmitted],
        ActionTypes[ActionType.RecommendationSubmitted],
        ActionTypes[ActionType.ConditionStatusManuallyOverridden],
        ActionTypes[ActionType.ReportInvalidated],
        ActionTypes[ActionType.UndoReportInvalidation],
        ActionTypes[ActionType.RecommendationEdited],
        ActionTypes[ActionType.AnalysisCommentEdited],
        ActionTypes[ActionType.AnalysisCommentDeleted],
        ActionTypes[ActionType.MarkedAsNoAction],
        ActionTypes[ActionType.UnmarkedAsNoAction],
        ActionTypes[ActionType.ActionOverdue],
        ActionTypes[ActionType.MeasurementSetAsReference],
    ],
    [ComponentType.Turbine]: [],
}
